
jQuery(document).ready(function() {

    if(jQuery('.page-template-template-cabinet').length) {

        const swiper_slider = new Swiper('section#slider .swiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            rewind: true,
			scrollbar: {
				el: '.swiper-scrollbar'
			},

        }); 

        var screen_center = jQuery(window).width() / 2;
        var offset_top_slider = jQuery('section#slider').offset().top;
        var offset_bottom_slider = offset_top_slider + jQuery('section#slider').outerHeight();

        document.addEventListener('cursormove', (e) => {

            // GESTION SLIDER slider
            var circle = jQuery('section#slider .rond_control');
            if (yPos > offset_top_slider-200 && yPos < offset_bottom_slider+200) {
                
                // Manage opacity depending on edge distance
                // opacity = Math.abs(xPos / jQuery(window).width() - 0.5) * 4;
                // opacity = Math.min(Math.max(opacity, 0.6), 1);
                // circle.css('opacity', opacity);

                // Switch left/right class depending on position relative to center
                if(xPos < screen_center) {
                    if(circle.hasClass('right')) {
                        circle.removeClass('right').addClass('left');
                        // circle.attr('data-bs-slide', 'prev');
                        // circle.data('slide', 'prev');
                    }
                } else {
                    if(circle.hasClass('left')) {
                        circle.removeClass('left').addClass('right');
                        // circle.attr('data-bs-slide', 'next');
                        // circle.data('slide', 'next');
                    }
                }
            }

        }, false);

        
        // DECLENCHEMENT SLIDE AU CLIC
        var circle_slider = jQuery('section#slider .rond_control');
        jQuery(circle_slider).on('click',function () { 
            if(circle_slider.hasClass('left')) {
                swiper_slider.slidePrev();
            }
            if(circle_slider.hasClass('right')) {
                swiper_slider.slideNext();
            }
        });

        // ON RESIZE, UPDATE STATIC INFOS
        document.addEventListener('windowresize', (e) => {
            screen_center = jQuery(window).width() / 2;
            offset_top_accueil = jQuery('section#slider').offset().top;
            offset_bottom_accueil = offset_top_accueil + jQuery('section#slider').outerHeight();

        }, false);

    }

    if(jQuery('.page-template-template-accueil').length) {

        // INITIALISATION SLIDERS
        const swiper_slider = new Swiper('section#slider .swiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            rewind: true,
			scrollbar: {
				el: '.swiper-scrollbar'
			},

        });
		const swiper_expertise = new Swiper('section#expertise .swiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            rewind: true,
			scrollbar: {
				el: '.swiper-scrollbar'
			},

        });
        const swiper_equipe = new Swiper('div#slider_equipe .swiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            rewind: true,
			scrollbar: {
				el: '.swiper-scrollbar'
			},

        });

        // GESTION RONDS DANS SLIDERS
        var screen_center = jQuery(window).width() / 2;
        var offset_top_accueil = jQuery('section#slider').offset().top;
        var offset_bottom_accueil = offset_top_accueil + jQuery('section#slider').outerHeight();
        var offset_top_expertise = jQuery('section#expertise').offset().top;
        var offset_bottom_expertise = offset_top_expertise + jQuery('section#expertise').outerHeight();
        var offset_top_equipe = jQuery('div#slider_equipe').offset().top;
        var offset_bottom_equipe = offset_top_equipe + jQuery('div#slider_equipe').outerHeight();

        // Slider equipe
        var slider_equipe_left = jQuery('div#slider_equipe').offset().left;
        var slider_equipe_width = jQuery('div#slider_equipe').outerWidth();
        var slider_equipe_center = slider_equipe_left + (slider_equipe_width / 2);

        document.addEventListener('cursormove', (e) => {

            // GESTION SLIDER ACCUEIL
            var circle = jQuery('section#slider .rond_control');
            if (yPos > offset_top_accueil-200 && yPos < offset_bottom_accueil+200) {
                
                // Manage opacity depending on edge distance
                // opacity = Math.abs(xPos / jQuery(window).width() - 0.5) * 4;
                // opacity = Math.min(Math.max(opacity, 0.6), 1);
                // circle.css('opacity', opacity);

                // Switch left/right class depending on position relative to center
                if(xPos < screen_center) {
                    if(circle.hasClass('right')) {
                        circle.removeClass('right').addClass('left');
                        // circle.attr('data-bs-slide', 'prev');
                        // circle.data('slide', 'prev');
                    }
                } else {
                    if(circle.hasClass('left')) {
                        circle.removeClass('left').addClass('right');
                        // circle.attr('data-bs-slide', 'next');
                        // circle.data('slide', 'next');
                    }
                }
            }

            // GESTION SLIDER EXPERTISE
            var circle = jQuery('section#expertise .rond_control');
            if (yPos > offset_top_expertise-200 && yPos < offset_bottom_expertise+200) {

                // Switch left/right class depending on position relative to center
                if(xPos < screen_center) {
                    if(circle.hasClass('right')) {
                        circle.removeClass('right').addClass('left');
                        circle.attr('data-bs-slide', 'prev');
                        circle.data('slide', 'prev');
                    }
                } else {
                    if(circle.hasClass('left')) {
                        circle.removeClass('left').addClass('right');
                        circle.attr('data-bs-slide', 'next');
                        circle.data('slide', 'next');
                    }
                }
            }


            // GESTION SLIDER EQUIPE
            var circle = jQuery('div#slider_equipe .rond_control');
            if (yPos > offset_top_equipe-200 && yPos < offset_bottom_equipe+200) {

                // Switch left/right class depending on position relative to center
                if(xPos < slider_equipe_center) {
                    if(circle.hasClass('right')) {
                        circle.removeClass('right').addClass('left');
                        circle.attr('data-bs-slide', 'prev');
                        circle.data('slide', 'prev');
                    }
                } else {
                    if(circle.hasClass('left')) {
                        circle.removeClass('left').addClass('right');
                        circle.attr('data-bs-slide', 'next');
                        circle.data('slide', 'next');
                    }
                }
            }

        }, false);

        
        // DECLENCHEMENT SLIDE AU CLIC
        var circle_slider = jQuery('section#slider .rond_control');
        jQuery(circle_slider).on('click', function () { 
            if(circle_slider.hasClass('left')) {
                swiper_slider.slidePrev();
            }
            if(circle_slider.hasClass('right')) {
                swiper_slider.slideNext();
            }
        });
        var circle_expertise = jQuery('section#expertise .rond_control');
        jQuery(circle_expertise).on('click',function () { 
            if(circle_expertise.hasClass('left')) {
                swiper_expertise.slidePrev();
            }
            if(circle_expertise.hasClass('right')) {
                swiper_expertise.slideNext();
            }
        });

        var circle_slider_equipe = jQuery('div#slider_equipe .rond_control');
        const obj_swiper_equipe = document.querySelector('div#slider_equipe .swiper');
        const swiper_equipe_ = obj_swiper_equipe.swiper;
        jQuery(circle_slider_equipe).on('click',function () { 
            if(circle_slider_equipe.hasClass('left')) {
                swiper_equipe_.slidePrev();
            }
            if(circle_slider_equipe.hasClass('right')) {
                swiper_equipe_.slideNext();
            }
        });


        // GESTION GROSSISSAGE ROND TRANSITION VERS EXPERTISE
        var rond_bouton = jQuery('section#equipe .rond_bouton');
        var original_size = rond_bouton.outerHeight();
        var target_size = 150;
        var inside_zone = 600;
        var inside_zone_margin = 50;
        var outside_zone = 400;
        var equipe_top = jQuery('section#equipe').offset().top;
        var equipe_height = jQuery('section#equipe').outerHeight();
        var equipe_bottom = equipe_top + equipe_height;
        document.addEventListener('cursormove', (e) => {
                
            // Gestion grossisage haut
            if(yPos > equipe_top - outside_zone && yPos < equipe_top + inside_zone) {
                transform_state = 1 - ((yPos - equipe_top - inside_zone_margin) / (inside_zone - inside_zone_margin));
                transform_state = Math.max(Math.min(transform_state, 1), 0);
                new_size = ((target_size - original_size) * transform_state) + original_size;
                rond_bouton.css('height', new_size+'px');
                rond_bouton.css('width', new_size+'px');
                rond_bouton.css('transition', 'none');
            }
            
            // Gestion grossisage bas
            else if(yPos > equipe_bottom - inside_zone && yPos < equipe_bottom + outside_zone) {
                transform_state = 1 - ((equipe_bottom - yPos) / (inside_zone));
                transform_state = Math.max(Math.min(transform_state-0.3, 1), 0);
                new_size = ((0 - original_size) * transform_state) + original_size;
                
                rond_bouton.css('height', new_size+'px');
                rond_bouton.css('width', new_size+'px');
                rond_bouton.css('transition', 'none');
            } 
            else {
                rond_bouton.css('height', '');
                rond_bouton.css('width', '');
                rond_bouton.css('transition', '');
            }

            

        }, false);

        
        // ON RESIZE, UPDATE STATIC INFOS
        document.addEventListener('windowresize', (e) => {
            screen_center = jQuery(window).width() / 2;
            offset_top_accueil = jQuery('section#slider').offset().top;
            offset_bottom_accueil = offset_top_accueil + jQuery('section#slider').outerHeight();
            offset_top_expertise = jQuery('section#expertise').offset().top;
            offset_bottom_expertise = offset_top_expertise + jQuery('section#expertise').outerHeight();
            offset_top_equipe = jQuery('div#slider_equipe').offset().top;
            offset_bottom_equipe = offset_top_equipe + jQuery('div#slider_equipe').outerHeight();
            equipe_top = jQuery('section#equipe').offset().top;
            equipe_height = jQuery('section#equipe').outerHeight();
            equipe_bottom = equipe_top + equipe_height;
        }, false);

    }
});